export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14349.34b43db3.jpg";